var _path, _path2, _g, _path3, _path4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZuno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 25,
    viewBox: "0 0 50 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_345)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_345",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0574 0H0V25H24.0574V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_345)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_20_345",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0122 0.0169067V12.7451C19.0122 16.6667 15.8789 19.858 12.0287 19.858C8.17844 19.858 5.04515 16.6667 5.04515 12.7451V0.0169067H0.0166016V12.7451C0.0166016 19.4929 5.40694 24.9831 12.0287 24.9831C18.6504 24.9831 24.0408 19.4963 24.0408 12.7485V0.0169067H19.0122Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_20_345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0122 0.0169067V12.7451C19.0122 16.6667 15.8789 19.858 12.0287 19.858C8.17844 19.858 5.04515 16.6667 5.04515 12.7451V0.0169067H0.0166016V12.7451C0.0166016 19.4929 5.40694 24.9831 12.0287 24.9831C18.6504 24.9831 24.0408 19.4963 24.0408 12.7485V0.0169067",
    fill: "url(#paint0_linear_20_345)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_20_345",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 0,
    width: 25,
    height: 25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H25.9393V25H50V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_20_345)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_20_345",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 0,
    width: 25,
    height: 25
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9592 12.2515V24.9797H30.9878V12.2515C30.9878 8.32996 34.1211 5.13861 37.9713 5.13861C41.8216 5.13861 44.9549 8.32996 44.9549 12.2515V24.9797H49.9834V12.2515C49.9834 5.50372 44.5931 0.0169067 37.9713 0.0169067C31.3496 0.0169067 25.9592 5.50372 25.9592 12.2515Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_20_345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9592 12.2515V24.9797H30.9878V12.2515C30.9878 8.32996 34.1211 5.13861 37.9713 5.13861C41.8216 5.13861 44.9549 8.32996 44.9549 12.2515V24.9797H49.9834V12.2515C49.9834 5.50372 44.5931 0.0169067 37.9713 0.0169067C31.3496 0.0169067 25.9592 5.50372 25.9592 12.2515Z",
    fill: "url(#paint1_linear_20_345)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_345",
    x1: 12.0287,
    y1: 24.9831,
    x2: 12.0287,
    y2: 0.0169067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_345",
    x1: 37.9713,
    y1: 0.0169067,
    x2: 37.9713,
    y2: 24.9797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZuno);
export default __webpack_public_path__ + "static/media/zuno.afcf32886f5fc6f64ada707540dc584c.svg";
export { ForwardRef as ReactComponent };